import {Box, Button, Menu} from '@viptech/react-components'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import actionsObject from 'src/images/actionsObject.svg'
import Camera from 'src/images/camerasBlack.svg'
import Config from 'src/images/config.svg'
import {EdgeServersDTO} from '../../../../services/api'

type Props = {
  server: EdgeServersDTO
}

function MenuOptions({server}: Props) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const navigate = useNavigate()
  const showCameras = server.cameras !== undefined && server.cameras > 0
  return (
    <>
      <Button variant='contained' color='transparent' onClick={(e) => setAnchor(e.currentTarget)} hoverColor='none'>
        <img src={actionsObject} alt='Menu logo' style={{width: 20, height: 20}} />
      </Button>
      <Menu anchor={anchor} onClose={() => setAnchor(null)} hideTriangle borderRadius='8px'>
        <Box display='flex' direction='column' padding='5px' justify='flex-start'>
          <Button variant='contained' color='transparent' hoverColor='#F5F5F5' onClick={() => navigate(`/registers/edge-servers?id=${server.id}`)}>
            <Box display='flex' columnGap='8px' align='center' justify='center' fontSize='12px'>
              <img src={Config} alt='Menu logo' style={{width: 15, height: 16}} />
              <span style={{color: '#364152'}}>Configurar Servidor</span>
            </Box>
          </Button>

          {showCameras && (
            <Button variant='contained' color='transparent' hoverColor='#F5F5F5' onClick={() => navigate(`/registers/devices?client=${server.clientId}`)}>
              <Box display='flex' columnGap='8px' align='center' justify='flex-start' fontSize='12px' width='100%'>
                <img src={Camera} alt='Menu logo' style={{width: 15, height: 16}} />
                <span style={{color: '#364152'}}>Listar Dispositivos</span>
              </Box>
            </Button>
          )}
        </Box>
      </Menu>
    </>
  )
}

export default MenuOptions
